// extracted by css-extract-rspack-plugin
export default {"cls1":"AiSummary-cls1_FhI","cls2":"AiSummary-cls2_x9h AiSummary-cls1_FhI"};